<template>
  <div id="dashboard">
    <main-layout>
      <v-tabs v-model="active" color="white" :slider-color="$vuetify.theme.primary">
        <v-tab v-if="isBU" ripple :key="'customers'" :href="'#customers'">{{
          $t('Customer')
        }}</v-tab>
        <v-tab ripple :key="'stat-summary'" :href="'#stat-summary'">{{ $t('Dashboard') }}</v-tab>
        <v-tab ripple :key="'active-user-graph'" :href="'#active-user-graph'">{{
          $t('Metrics')
        }}</v-tab>
        <v-tab ripple :key="'summary-intent'" :href="'#summary-intent'">{{
          $t('Conversation')
        }}</v-tab>
        <v-tab v-if="!isBU" ripple :key="'customers'" :href="'#customers'">{{
          $t('Customer')
        }}</v-tab>

        <v-tab v-if="isBU" ripple :key="'inbox-stat-register'" :href="'#inbox-stat-register'">{{
          $t('Register')
        }}</v-tab>
        <v-tab v-if="isBU" ripple :key="'inbox-stat-faculty'" :href="'#inbox-stat-faculty'">{{
          $t('Faculty')
        }}</v-tab>
        <v-tab
          v-if="isBU"
          ripple
          :key="'inbox-stat-scholarships'"
          :href="'#inbox-stat-scholarships'"
          >{{ $t('Scholarships') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-dashboard'"
          :href="'#aston-dashboard'"
          v-if="
            $store.state.astonpages.includes(selectedBot.pageid) &&
              $store.getters.getPackage == 'premium'
          "
          >{{ $t('Aston') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-line-dashboard'"
          :href="'#aston-line-dashboard'"
          v-if="
            $store.state.astonpages.includes(selectedBot.pageid) &&
              $store.getters.getPackage == 'premium'
          "
          >{{ $t('AstonLine') }}</v-tab
        >
        <v-tab
          ripple
          :key="'aston-outsource-dashboard'"
          :href="'#aston-outsource-dashboard'"
          v-if="
            $store.state.astonpages.includes(selectedBot.pageid) &&
              $store.getters.getPackage == 'premium'
          "
          >{{ $t('Outsource') }}</v-tab
        >
      </v-tabs>
      <template v-if="active == 'customers'">
        <component :is="active"></component>
      </template>
      <template v-else>
        <component :is="active"></component>
      </template>
    </main-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
import datepicker from 'vuejs-datepicker'
import moment from 'moment'
import numeral from 'numeral'
import $ from 'jquery'

// import StatSummary from '@/components/elements/MaintenancePage'
// import ActiveUserGraph from '@/components/elements/MaintenancePage'
// import SummaryIntent from '@/components/elements/MaintenancePage'
// import Customers from '@/components/elements/MaintenancePage'

import StatSummary from './StatSummary.vue'
import ActiveUserGraph from './ActiveUserGraph.vue'
import Customers from './Customers'
import SummaryIntent from './SummaryIntent.vue'

import InboxStatRegister from './InboxStatRegister.vue'
import InboxStatFaculty from './InboxStatFaculty.vue'
import InboxStatScholarships from './InboxStatScholarships.vue'

import AstonDashboard from './AstonDashboard.vue'
import AstonLineDashboard from './AstonLineDashboard.vue'
import AstonOutsourceDashboard from './AstonOutsourceDashboard.vue'

export default {
  data: function() {
    return {
      active: null,

      showIntent: false,
      currentView: 'statistic'
    }
  },
  components: {
    StatSummary,
    AstonDashboard,
    AstonLineDashboard,
    ActiveUserGraph,
    SummaryIntent,
    Customers,
    InboxStatRegister,
    InboxStatFaculty,
    AstonOutsourceDashboard,
    InboxStatScholarships
  },
  created: function() {
    let vm = this
    if (vm.$route.query.tab) {
      switch (vm.$route.query.tab) {
        case 'statistic':
        case 'crm':
        case 'custom_analytic':
          vm.currentView = vm.$route.query.tab
          break
        default:
          vm.currentView = 'statistic'
          break
      }
    } else {
      vm.currentView = 'statistic'
    }
  },
  mounted: function() {},
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    }
  },
  methods: {
    numberFormat: function(val) {
      return numeral(val).format('0,0')
    },
    updateRoute: function() {
      this.$router.push({
        name: 'dashboard',
        path: '/' + this.currentLang + '/dashboard',
        query: {
          tab: this.currentView
        }
      })
      this.routeValue = JSON.stringify(this.$route.query)
    }
  },
  watch: {
    currentView: function() {
      this.updateRoute()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Dashboard.vue